<template>
  <div class='oversea full_layout' v-loading.fullscreen="disabled">
    <div><img :src="`${baseUrl}/vault/img/v_01.jpg`"></div>
    <div><img :src="`${baseUrl}/vault/img/v_02.jpg`"></div>
    <div><img :src="`${baseUrl}/vault/img/v_03.jpg`"></div>
    <div><img :src="`${baseUrl}/vault/img/v_04.jpg`"></div>
    <div><img :src="`${baseUrl}/vault/img/v_05.jpg`"></div>
    <div><img :src="`${baseUrl}/vault/img/v_06.jpg`"></div>
  </div>
</template>
<script>
import bus from '@/api/bus';
export default {
  name: '',
  components: {},
  data() {
    return {
      disabled:false,
      baseUrl:process.env.VUE_APP_CARD_URL
    }
  },
  watch: {
  },
  mounted() {},
  created() {
    bus.$emit('headerTitle', this.$t('vault.CardHobbyVault'));
  },
  methods: {}
}

</script>
<style scoped>
.oversea{
  margin-top: 24px;
}
.oversea img{
  width: 100%;
  display: block;
  overflow: hidden;
}
.oversea>div{
  position: relative;
}
.oversea>div>span{
  position: absolute;
width: 203px;
    height: 34px;
    bottom: 167px;
    right: 367px;
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/vault.vue